import { gql, useApolloClient, useMutation, } from '@apollo/client';
import { OCCUPANT_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const OCCUPANT_WRITE = gql `
    ${OCCUPANT_FIELDS}
    mutation writeOccupant($dossierId: Long, $participants: [OccupantFormDtoInput]!) {
      write_occupant(dossierId: $dossierId, participants: $participants) {
        ...OccupantFields
      }
    }
  `;
export const useOccupantWriteMutation = (options) => useMutation(OCCUPANT_WRITE, options);
export const useOccupantWriteMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: OCCUPANT_WRITE, variables }));
};
